import { API, authClient } from "../index";

export const postProduct = async (product, accessToken) => {
	return authClient(accessToken).post(`${API}/products`, product);
};

export const getProducts = (accessToken) => {
	return authClient(accessToken).get(`${API}/products`);
};

export const getProductById = (id, accessToken) => {
	return authClient(accessToken).get(`${API}/products/${id}`);
};

export const getProductPriceHistory = (id, accessToken) => {
	return authClient(accessToken).get(`${API}/products/${id}/price-history`);
};

export const updateProduct = async (id, product, accessToken) => {
	return authClient(accessToken).put(`${API}/products/${id}`, product);
};

export const deleteProduct = (id, accessToken) => {
	return authClient(accessToken).delete(`${API}/products/${id}`);
};
